import { ActionBasic } from 'kts-scaffold-framework/modules';
import ModulesState from './Modules.State';
import { history } from 'kts-platform-frame/routes';

class ModulesAction extends ActionBasic<ModulesState> {
    /** 返回登陆页 */
    public go = (router) => {
        history.push(router);
    }
    /** 倒计时 */
    public countdwon = () => {
        this.modulesState.timer=setInterval(() => {
            if(this.modulesState.countDown > 0){
                this.modulesState.countDown = this.modulesState.countDown-1;
                this.setModulesState();
            } else {
                clearInterval(this.modulesState.timer);   
                this.go('/login');           
            }           
        },1000);
        this.setModulesState();
    }
}

export default new ModulesAction();


// WEBPACK FOOTER //
// ./src/display/platform/Network/PublicCompanyRegister/CompanyRegisterSucess/Modules.Action.ts